// 02.7-settings.md paso c -- adelgazamiento de WhatsPanel.jsx. Función pura, movida verbatim.
// Integración main→dev (catch-up F): los canales (`@newsletter`) se tratan como grupos (avatar
// cuadrado, etc.), igual que `@g.us`.
export function isGroupJid(jid) {
    const s = String(jid || '');
    return s.endsWith('@g.us') || s.endsWith('@newsletter') || s.includes('-') || (s.length > 15 && s.startsWith('120'));
}

// Integración main→dev (catch-up F): fusiona los chats vinculados (`linked_to_jid`) dentro de su
// chat padre en la bandeja — suma no leídos/menciones y adopta el último mensaje más reciente.
export function mergeLinkedChats(rawChats) {
    const merged = {};
    for (const c of rawChats) {
        if (!c.linked_to_jid) merged[c.chat_jid] = { ...c, child_jids: [] };
    }
    for (const c of rawChats) {
        const parent = c.linked_to_jid && merged[c.linked_to_jid];
        if (!parent) continue;
        parent.child_jids.push(c.chat_jid);
        parent.unread_count = (parent.unread_count || 0) + (c.unread_count || 0);
        parent.unread_mentions_count = (parent.unread_mentions_count || 0) + (c.unread_mentions_count || 0);
        if (new Date(c.last_message_timestamp) > new Date(parent.last_message_timestamp)) {
            parent.last_message_timestamp = c.last_message_timestamp;
            parent.last_message_text = c.last_message_text;
            parent.last_message_status = c.last_message_status;
        }
    }
    return Object.values(merged);
}
export function filterAndSortChats(chats, searchTerm, activeFilter) {
  const query = (searchTerm || '').toLowerCase();
  const filterVal = (activeFilter || 'Todos').toLowerCase();

  const filtered = chats.filter((chat) => {
    const matchesSearch =
      (chat.name && chat.name.toLowerCase().includes(query)) ||
      (chat.chat_jid && chat.chat_jid.toLowerCase().includes(query));

    if (!matchesSearch) return false;

    if (filterVal === "no leídos" || filterVal === "no leidos") {
      return chat.unread_count > 0;
    }

    if (filterVal === "importantes") {
      return chat.priority === "urgente" || chat.priority === "alta";
    }

    if (filterVal === "flow") {
      return chat.unread_count > 0 || chat.priority === "urgente" || chat.priority === "alta";
    }

    return true;
  });

  const getSafeTime = (ts) => {
    if (!ts) return 0;
    const time = new Date(ts).getTime();
    return isNaN(time) ? 0 : time;
  };

  filtered.sort((a, b) => {
    if (filterVal === "todos") {
      return getSafeTime(b.last_message_timestamp) - getSafeTime(a.last_message_timestamp);
    }

    if (filterVal !== "importantes") {
      const aUnread = a.unread_count > 0 ? 1 : 0;
      const bUnread = b.unread_count > 0 ? 1 : 0;
      if (aUnread !== bUnread) {
        return bUnread - aUnread;
      }
    }
    
    const pA = a.priority || 'baja';
    const pB = b.priority || 'baja';
    const priorityA = pA === 'urgente' ? 3 : pA === 'alta' ? 2 : 1;
    const priorityB = pB === 'urgente' ? 3 : pB === 'alta' ? 2 : 1;
    
    if (priorityA !== priorityB) {
      return priorityB - priorityA;
    }

    return getSafeTime(b.last_message_timestamp) - getSafeTime(a.last_message_timestamp);
  });

  return filtered;
}
